import { digitalAssetsBuyUsdcWithBank, digitalAssetsUsdcWithdraw, sendDigitalAsset } from 'api/apiDataHelpers'
import { getRequest, getRequestV2, getRequestV3, postRequest, postRequestV2 } from 'api/apiUtils'
import { IS_PRODUCTION } from 'utils/helperConfig'
import { all, call, put, takeLatest } from 'redux-saga/effects'
import UserActionTypes from 'redux/user/user-types'
import * as digitalAssetDeskActions from './digitalAssets-actions'
import DigitalAssetsActionTypes from './digitalAssets-types'

function* signInSuccess() {
    yield put(digitalAssetDeskActions.startFetchAvailableDigitalAssets())
}

export function* onSignSuccess() {
    yield takeLatest(UserActionTypes.SIGN_IN_SUCCESS, signInSuccess)
}

function* startFetchAvailableDigitalAssets() {
    try {
        const { data } = yield getRequestV2('/user/digitalAssets/wallets/available')
        yield put(digitalAssetDeskActions.successFetchAvailableDigitalAssets(data))
    } catch {
        yield put(digitalAssetDeskActions.failureFetchAvailableDigitalAssets())
    }
}

export function* onStartFetchAvailableDigitalAssets() {
    yield takeLatest(DigitalAssetsActionTypes.START_FETCH_AVAILABLE_DIGITAL_ASSETS, startFetchAvailableDigitalAssets)
}

function* startAddDigitalAsset({ payload: data }) {
    try {
        yield postRequest('/user/digitalAssets/wallets', { currencyCode: `${data}` })
        yield put(digitalAssetDeskActions.successAddDigitalAsset())
        yield put(digitalAssetDeskActions.startFetchAvailableDigitalAssets())
        yield put(digitalAssetDeskActions.completeLoaderAddDigitalAsset())
    } catch (err) {
        yield put(digitalAssetDeskActions.failureAddDigitalAsset({ errorMessage: err?.response?.data?.errors }))
    }
}

export function* onStartAddDigitalAsset() {
    yield takeLatest(DigitalAssetsActionTypes.START_ADD_DIGITAL_ASSET, startAddDigitalAsset)
}

function* startSendDigitalAssetsAmount({ payload: { id, amount, address, verificationCode, tag, label, templateNo, save, blockchainNetwork } }) {
    try {
        yield postRequestV2(`/user/digitalAssets/wallets/${id}/send`, sendDigitalAsset({ amount, address, verificationCode, tag, label, templateNo, save, blockchainNetwork }))
        yield put(digitalAssetDeskActions.successSendDigitalAssetsAmount())
    } catch (err) {
        yield put(digitalAssetDeskActions.failureSendDigitalAssetsAmount({ errorMessage: err?.response?.data?.errors }))
    }
}

export function* onStartSendDigitalAssetsAmount() {
    yield takeLatest(DigitalAssetsActionTypes.START_SEND_DIGITAL_ASSETS_AMOUNT, startSendDigitalAssetsAmount)
}

function* startBuyUsdcCoinWithBank({
    payload: { amount, name, account, address, city, country, bic, bankName, bankAddress, bankCity, bankCountry, postCode, bankPostCode, paymentReference, districtCode },
}) {
    try {
        const dataToSend = digitalAssetsBuyUsdcWithBank({
            amount,
            name,
            account,
            address,
            city,
            country,
            bic,
            bankName,
            bankAddress,
            bankCity,
            bankCountry,
            postCode,
            bankPostCode,
            paymentReference,
            districtCode,
        })
        const { data } = yield postRequest(`/user/digitalAssets/wallets/usdc/buy-by-bank`, dataToSend)
        yield put(digitalAssetDeskActions.successBuyUsdcCoinWithBank(data))
    } catch (err) {
        yield put(digitalAssetDeskActions.failureBuyUsdcCoinWithBank({ errorMessage: err?.response?.data?.errors }))
    }
}

export function* onStartBuyUsdcCoinWithBank() {
    yield takeLatest(DigitalAssetsActionTypes.START_BUY_USDC_COIN_WITH_BANK, startBuyUsdcCoinWithBank)
}

function* startTransferUsdcCoin({
    payload: {
        amount,
        currencyCode,
        name,
        account,
        address,
        city,
        country,
        bic,
        bankName,
        bankAddress,
        bankCity,
        bankCountry,
        postCode,
        bankPostCode,
        paymentReference,
        verificationCode,
        districtCode,
    },
}) {
    try {
        const dataToSend = digitalAssetsUsdcWithdraw({
            amount,
            currencyCode,
            name,
            account,
            address,
            city,
            country,
            bic,
            bankName,
            bankAddress,
            bankCity,
            bankCountry,
            postCode,
            bankPostCode,
            paymentReference,
            verificationCode,
            districtCode,
        })
        yield postRequest(`/user/digitalAssets/wallets/usdc/sell`, dataToSend)
        yield put(digitalAssetDeskActions.successTransferUsdcCoin())
    } catch (err) {
        yield put(digitalAssetDeskActions.failureTransferUsdcCoin({ errorMessage: err?.response?.data?.errors }))
    }
}

export function* onStartTransferUsdcCoin() {
    yield takeLatest(DigitalAssetsActionTypes.START_TRANSFER_USDC_COIN, startTransferUsdcCoin)
}

function* startSendUsdcCoin({ payload: { id, address, tag, amount, verificationCode } }) {
    try {
        yield postRequest(`/user/digitalAssets/wallets/usdc/${id}/send`, { address, tag, amount, verificationCode })
        yield put(digitalAssetDeskActions.successSendUsdcCoin())
    } catch (err) {
        yield put(digitalAssetDeskActions.failureSendUsdcCoin({ errorMessage: err?.response?.data?.errors }))
    }
}

export function* onStartSendUsdcCoin() {
    yield takeLatest(DigitalAssetsActionTypes.START_SEND_USDC_COIN, startSendUsdcCoin)
}

function* startGetEncryptionKey() {
    try {
        const { data } = yield getRequest(`/user/digitalAssets/wallets/usdc/buy/encryption-key`)
        yield put(digitalAssetDeskActions.successGetEncryptionKey(data))
    } catch (err) {
        yield put(digitalAssetDeskActions.failureGetEncryptionKey({ errorMessage: err?.response?.data?.errors }))
    }
}

export function* onStartGetEncryptionKey() {
    yield takeLatest(DigitalAssetsActionTypes.START_GET_ENCRYPTION_KEY, startGetEncryptionKey)
}

function* startReceiveDigitalAssetBenaficiaries({ payload: { currencyCode } }) {
    try {
        const { data } = yield getRequest(`/user/digitalAssets/wallets/beneficiaries/${currencyCode}`)
        yield put(digitalAssetDeskActions.successReceiveDigitalAssetBenaficiaries(data))
    } catch (err) {
        yield put(digitalAssetDeskActions.failureReceiveDigitalAssetBenaficiaries({ errorMessage: err?.response?.data?.errors }))
        if (!IS_PRODUCTION) {
            console.log('error on get digital asset beneficiaries', err)
        }
    }
}
export function* onstartReceiveDigitalAssetBenaficiaries() {
    yield takeLatest(DigitalAssetsActionTypes.START_RECEIVE_DIGITAL_ASSET_BENEFICIARIES, startReceiveDigitalAssetBenaficiaries)
}

function* startGetDigitalAssetWalletById({ payload: { identifier } }) {
    try {
        const { data } = yield getRequestV3(`/user/digitalAssets/wallets/${identifier}`)
        yield put(digitalAssetDeskActions.successGetDigitalAssetWalletById(data))
    } catch (err) {
        yield put(digitalAssetDeskActions.failureGetDigitalAssetWalletById({ errorMessage: err?.response?.data?.errors }))
        if (!IS_PRODUCTION) {
            console.log('error on get digital asset beneficiaries', err)
        }
    }
}
export function* onStartGetDigitalAssetWalletById() {
    yield takeLatest(DigitalAssetsActionTypes.START_GET_DIGITAL_ASSET_WALLET_BY_ID, startGetDigitalAssetWalletById)
}

function* startGetDigitalAssetWalletAddressType({ payload: { address, tag, blockchainNetwork, currencyCode } }) {
    try {
        const { data } = yield postRequest('/user/digitalAssets/wallets/belongs-in-system', { address, tag, blockchainNetwork, currencyCode })
        yield put(digitalAssetDeskActions.successGetDigitalAssetWalletAddressType(data))
    } catch (err) {
        yield put(digitalAssetDeskActions.failureGetDigitalAssetWalletAddressType({ errorMessage: err?.response?.data?.errors }))
        if (!IS_PRODUCTION) {
            console.log('error on get digital asset wallet type', err)
        }
    }
}
export function* onStartGetDigitalAssetWalletAddressType() {
    yield takeLatest(DigitalAssetsActionTypes.START_GET_DIGITAL_ASSET_WALLET_ADDRESS_TYPE, startGetDigitalAssetWalletAddressType)
}

export function* digitalAssetSagas() {
    yield all([
        call(onSignSuccess),
        call(onStartFetchAvailableDigitalAssets),
        call(onStartAddDigitalAsset),
        call(onStartSendDigitalAssetsAmount),
        call(onStartTransferUsdcCoin),
        call(onStartGetEncryptionKey),
        call(onStartBuyUsdcCoinWithBank),
        call(onStartSendUsdcCoin),
        call(onstartReceiveDigitalAssetBenaficiaries),
        call(onStartGetDigitalAssetWalletById),
        call(onStartGetDigitalAssetWalletAddressType),
    ])
}
